// extracted by mini-css-extract-plugin
module.exports = {"container":"privacyPolicy-mod__container___34CN8","textWrapper":"privacyPolicy-mod__textWrapper___SpTld","fading":"privacyPolicy-mod__fading___2bU7I"};